import { InventoryTemplateWebComponent } from './component/InventoryTemplateWebComponent';

export { InventoryTemplateWebComponent };
